import { parseDate } from '@ais-ui/utils';
import { QueryPointResult } from '../queryPointResult';

export interface SeaStateReport {
  seaState: string;
  signWaveHeight: string;
  swellSensorDataDesc: string;
  swellDirection: string;
  swellHeight: string;
  swellPeriod: string;
  temp_sensor_data_desc: string;
  seaStateTimestamp: Date | null;
  waterTemperature: string;
  waterTemperatureDepth: string;
  waveDirection: string;
  wavePeriod: string;
  waveSensorDataDesc: string;
}

const desiredTargetName: string[] = [
  'sea_state',
  'sign_wave_height',
  'swell_sensor_data_desc',
  'swell_direction',
  'swell_height',
  'swell_period',
  'temp_sensor_data_desc',
  'timestamp',
  'water_temperature',
  'water_temperature_depth',
  'wave_direction',
  'wave_period',
  'wave_sensor_data_desc',
];

export function extractEnvironmentalSeaStateReport(
  result: QueryPointResult,
): SeaStateReport {
  const rawWeatherReportInfo: { [key: string]: any } = {};
  for (const target of result.targetInfo) {
    const weatherReport = target?.values_json['sea_state_report'];
    if (weatherReport) {
      for (const [report_key, report_value] of Object.entries(weatherReport)) {
        if (desiredTargetName.includes(report_key)) {
          rawWeatherReportInfo[report_key] = report_value;
        }
      }
    }
  }
  return {
    seaState: rawWeatherReportInfo['sea_state'],
    signWaveHeight: rawWeatherReportInfo['sign_wave_height'],
    swellSensorDataDesc: rawWeatherReportInfo['swell_sensor_data_desc'],
    swellDirection: rawWeatherReportInfo['swell_direction'],
    swellHeight: rawWeatherReportInfo['swell_height'],
    swellPeriod: rawWeatherReportInfo['swell_period'],
    temp_sensor_data_desc: rawWeatherReportInfo['temp_sensor_data_desc'],
    seaStateTimestamp: rawWeatherReportInfo['timestamp']
      ? parseDate(rawWeatherReportInfo['timestamp'])
      : null,
    waterTemperature: rawWeatherReportInfo['water_temperature'],
    waterTemperatureDepth: rawWeatherReportInfo['water_temperature_depth'],
    waveDirection: rawWeatherReportInfo['wave_direction'],
    wavePeriod: rawWeatherReportInfo['wave_period'],
    waveSensorDataDesc: rawWeatherReportInfo['wave_sensor_data_desc'],
  };
}
